import { STRIPE_LIST } from "../action/type";

const initialState = {
  list: [{}],
};
const Stripe = function (state = initialState, action) {
  switch (action.type) {
    case STRIPE_LIST:
      return { ...state, list: action.payload };
    default:
      return state;
  }
};
export default Stripe;
